import { defineComponent as _defineComponent } from 'vue';
import BreezeApplicationLogo from '@/Components/Layout/ApplicationLogoWhite.vue';
import { Link } from '@inertiajs/inertia-vue3';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Guest',
    setup(__props, { expose }) {
        expose();
        const __returned__ = { BreezeApplicationLogo, get Link() { return Link; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
